export interface KbStateInterface {
  entities: any;
  synonyms: {
    columns: any[];
    data: any[];
  };
  descriptions: {
    columns: any[];
    data: any[];
  };
}

function state(): KbStateInterface {
  return {
    entities: {},
    synonyms: {
      columns: [
        {
          name: "id",
          label: "id",
          field: "id",
          align: "left",
          sortable: true,
          style: "width: 10px",
        },
        {
          name: "synonym",
          label: "synonym",
          field: "synonym",
          align: "left",
          sortable: true,
        },
      ],
      data: [],
    },
    descriptions: {
      columns: [
        {
          name: "id",
          label: "id",
          field: "id",
          align: "left",
          sortable: true,
          style: "width: 10px",
        },
        {
          name: "class_id",
          label: "class_id",
          field: "class_id",
          align: "left",
          sortable: true,
        },
        {
          name: "description",
          label: "description",
          field: "description",
          align: "left",
          sortable: true,
        },
      ],
      data: [],
    },
  };
}

export default state;
